import { useQueryParams } from "@/hooks/useQueryParams";
import { useSelector } from "react-redux";
import TicketList from "./TicketList";
import SupportInboxMessages from "./SupportInboxMessages";
import { Menu, Spin } from "antd";
import { useGetSupportSummaryQuery } from "@/redux/api/supportApi";
import { userRole } from "@/constant";
import { AppstoreOutlined, DesktopOutlined, DollarOutlined, UserOutlined } from "@ant-design/icons";
import PropTypes from "prop-types";
import { MdOutlineSupportAgent } from "react-icons/md";

const categories = [
  { key: "technical", label: "Technical", icon: <DesktopOutlined /> },
  { key: "administrative", label: "Administrative", icon: <UserOutlined /> },
  { key: "finance", label: "Finance", icon: <DollarOutlined /> },
  { key: "others", label: "Others", icon: <AppstoreOutlined /> },
];

const MainMenu = ({ onSelect, selectedKey, summary, mode }) => (
  <Menu mode={mode} selectedKeys={[selectedKey]} onClick={({ key }) => onSelect(key)} className="h-100 border-end-0">
    <Menu.Item key="" icon={<MdOutlineSupportAgent />}>
      <div className="d-lg-flex d-inline-flex flex-row justify-content-between align-items-center">
        <span> All </span>
        <span className="text-secondary ms-2">{Object?.keys(summary || {})?.reduce((a, b) => a + summary[b], 0)}</span>
      </div>
    </Menu.Item>
    {categories.map((cat) => (
      <Menu.Item key={cat.key} icon={cat.icon}>
        <div className="d-lg-flex d-inline-flex flex-row justify-content-between align-items-center">
          <span>{cat.label}</span>
          <span className="text-secondary ms-2">{summary?.[cat.key] || 0}</span>
        </div>
      </Menu.Item>
    ))}
  </Menu>
);

MainMenu.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selectedKey: PropTypes.string,
  summary: PropTypes.object,
  mode: PropTypes.string.isRequired,
};

export default function SupportInbox() {
  // hooks
  const { queryParams, setQueryParams } = useQueryParams({ type: "" });
  const user = useSelector((state) => state.user?.userDetails) || {};

  //   rtk query
  const {
    isLoading: summaryLoading,
    data: summary,
    refetch,
  } = useGetSupportSummaryQuery({ user: user?.role !== userRole.superAdmin ? user?._id : undefined });

  const loading = summaryLoading;

  return (
    <Spin spinning={loading} wrapperClassName="h-100">
      <div className="h-100 d-flex flex-column   ">
        {/* <PageHeader title="Support" subTitle="Support Inbox" /> */}
        <div className="d-flex flex-column h-100 flex-lg-row overflow-hidden font-sans">
          {/* small screen */}
          <div className="py-2 d-lg-none">
            <MainMenu onSelect={(key) => setQueryParams({ type: key })} selectedKey={queryParams?.type} summary={summary?.data} mode="horizontal" />
          </div>

          {/* big screen */}
          <div className="pt-2 h-100 d-none d-lg-block">
            <MainMenu
              onSelect={(key) => setQueryParams({ type: key, inbox: undefined })}
              selectedKey={queryParams?.type}
              summary={summary?.data}
              mode="inline"
            />
          </div>

          {/* Main Content Area */}
          <div className="d-flex overflow-y-scroll flex-column flex-md-row w-100 no-scrollbar">
            {/* Ticket List Column */}
            <TicketList refetch={refetch} />

            {/* Main View Column */}
            <div className="d-flex justify-content-center p-4 support-message">
              <SupportInboxMessages />
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
}
